export enum RBACPermissions {
  CAN_SUBSCRIPTION = 'CAN_SUBSCRIPTION',
}
